import { render, staticRenderFns } from "./packaging-gnxsp.vue?vue&type=template&id=2a20a994"
import script from "./packaging-gnxsp.vue?vue&type=script&lang=js"
export * from "./packaging-gnxsp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports